
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.5 4a7.5 7.5 0 00-6 3A7.5 7.5 0 003 11.5c0 8.988 12.488 16.075 13.012 16.375A.975.975 0 0016.5 28a.95.95 0 00.488-.125 39.289 39.289 0 006.437-4.7C27.788 19.25 30 15.325 30 11.5A7.5 7.5 0 0022.5 4z","fill":"currentColor"}})])
          )
        }
      }
    